import React from 'react';
import { BannerImageProps } from '../types';
import { BannerImageStyles } from '../styles';

export const BannerImage: React.FC<BannerImageProps> = props => {
  const { pictureUrl } = props;

  return <img className={BannerImageStyles} src={pictureUrl} alt="Реклама" loading="lazy" />;
};
